import { CSSProperties, useState } from "react";
import { Link } from "react-router-dom";
import { PublicBaseView } from "./PublicBaseView";
import { useAsyncEffect } from "../utils/hooks";
import { API_STORE } from "../ApiStore";

interface CategoryWithCount {
  id: string;
  description: string;
  order: number;
  count: number;
}

const gridStyle: CSSProperties = {
  display: "flex",
  flexWrap: "wrap",
  gap: "20px",
  marginTop: "20px"
};

const categoryCardStyle: CSSProperties = {
  width: "calc(33.333% - 15px)",
  minWidth: "250px",
  border: "1px solid #ddd",
  borderRadius: "8px",
  padding: "15px",
  textAlign: "center",
  textDecoration: "none",
  color: "inherit",
  transition: "box-shadow 0.2s",
  cursor: "pointer"
};

const categoryTitleStyle: CSSProperties = {
  fontSize: "18px",
  fontWeight: "bold",
  margin: "10px 0",
  color: "#333"
};

const categoryCountStyle: CSSProperties = {
  fontSize: "14px",
  color: "#666"
};

export function PublicCategories() {
  const [categories, setCategories] = useState<CategoryWithCount[]>([]);
  const [loading, setLoading] = useState(true);
  const root = process.env.PUBLIC_URL || "";

  useAsyncEffect(async () => {
    try {
      const data = await API_STORE.doFetch("get", "/public/categories", { jsonBody: null });
      setCategories(data);
    } catch (error) {
      console.error("Error loading categories:", error);
      alert("Greška pri učitavanju kategorija");
    } finally {
      setLoading(false);
    }
  }, []);

  const handleCardHover = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.currentTarget.style.boxShadow = "0 4px 8px rgba(0,0,0,0.1)";
  };

  const handleCardLeave = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.currentTarget.style.boxShadow = "none";
  };

  return (
    <PublicBaseView>
      <h2>Kategorije fotografija</h2>
      {loading ? (
        <p>Učitavanje...</p>
      ) : categories.length === 0 ? (
        <p>Nema dostupnih kategorija</p>
      ) : (
        <div style={gridStyle}>
          {categories.map((category) => (
            <Link
              key={category.id}
              to={`${root}/public/category/${category.id}`}
              style={categoryCardStyle}
              onMouseEnter={handleCardHover}
              onMouseLeave={handleCardLeave}
            >
              <div style={categoryTitleStyle}>{category.description}</div>
              <div style={categoryCountStyle}>
                {category.count} {category.count === 1 ? "fotografija" : "fotografija"}
              </div>
            </Link>
          ))}
        </div>
      )}
    </PublicBaseView>
  );
}
